var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contestantBox"},_vm._l((_vm.playerList),function(player){return _c('Player',{key:player.name,attrs:{"name":player.name,"score":player.score}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }